import { render, staticRenderFns } from "./Slot.vue?vue&type=template&id=1f8d7dc4&scoped=true"
import script from "./Slot.vue?vue&type=script&lang=js"
export * from "./Slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8d7dc4",
  null
  
)

export default component.exports